import React from 'react';
import { Input } from '../../ui/Input';

export const TabContact = ({ card, updateCard }) => {
  const vis = card.contact_visibility || { email: true, phone: true, website: true, location: true };
  const setVis = (field, val) => updateCard('contact_visibility', { ...vis, [field]: val });

  return (
    <div className="space-y-8">
      <p className="text-sm text-slate-500 border-b border-slate-100 pb-4">
        Add contact details and choose whether they appear on your public card.
      </p>
      
      {['email', 'phone', 'website'].map(field => (
        <div key={field} className="flex flex-col sm:flex-row gap-4 items-start sm:items-end">
          <div className="flex-1 w-full">
            <Input 
              label={field.charAt(0).toUpperCase() + field.slice(1)} 
              value={card[field] || ''} 
              onChange={e => updateCard(field, e.target.value)} 
            />
          </div>
          <label className="flex items-center space-x-2 pb-2 cursor-pointer shrink-0">
            <input 
              type="checkbox" 
              checked={vis[field]} 
              onChange={e => setVis(field, e.target.checked)} 
              className="rounded border-slate-300 w-5 h-5 text-slate-900 focus:ring-slate-900" 
            />
            <span className="text-sm font-medium text-slate-700">Show on card</span>
          </label>
        </div>
      ))}
    </div>
  );
};